import { assertEvent, enqueueActions } from 'xstate5';

import { findActiveModification, getDressingPortionSize } from '../../helpers';
import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Raises the corresponding events to increase or decrease the portions based
 * on the provided portions number.
 */
export const changeDressingPortions: CustomizationMachineAction = enqueueActions(
  ({ enqueue, event, context }) => {
    assertEvent(event, 'customization.dressing.change-portions');

    const { modifications, mixedDressingDetails } = context;
    const { ingredientId, portions } = event;

    const activeModifications = modifications?.active ?? [];
    const activeModification = findActiveModification(ingredientId, activeModifications); // prettier-ignore

    if (!activeModification) return;

    const currentPortions = getDressingPortionSize(activeModification, mixedDressingDetails); // prettier-ignore
    const changesCount = portions - currentPortions;
    const numberOfActions = Math.abs(changesCount);
    const operations = Array.from({ length: numberOfActions });

    const shouldIncreasePortions = changesCount > 0;
    const shouldDecreasePortions = changesCount < 0;

    if (changesCount === 0) return;

    const increasePortions = () => enqueue.raise({ type: 'customization.dressing.increase-portions', ingredientId }); // prettier-ignore
    const decreasePortions = () => enqueue.raise({ type: 'customization.dressing.decrease-portions', ingredientId }); // prettier-ignore

    if (shouldDecreasePortions) operations.forEach(decreasePortions);
    if (shouldIncreasePortions) operations.forEach(increasePortions);
  },
);
